/*
 * I18n Polyfill — Safe fallback for window.I18n.t()
 *
 * Provides a minimal I18n.t() implementation so modules that call
 * I18n.t() during object literal creation (at load time) don't crash
 * with ReferenceError. Returns the last segment of the translation key
 * as a human-readable placeholder. Real translations loaded later will
 * override this polyfill.
 */
if (typeof window.I18n === 'undefined') {
    window.I18n = {
        t: function (key, options) {
            if (options && options.defaults && options.defaults[0] && options.defaults[0].message) {
                return options.defaults[0].message;
            }
            var parts = key.split('.');
            // Return last segment, replace underscores with spaces
            return parts[parts.length - 1].replace(/_/g, ' ');
        },
        locale: 'en'
    };
}
